export default "__VITE_ASSET__31d8e4c5__"